import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "product-carousel-v2__list-wrapper" }
const _hoisted_2 = { class: "product-carousel-v2__actions" }
const _hoisted_3 = { class: "product-carousel-v2__navigation" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

import { onMounted, ref, nextTick, computed } from 'vue';
import useWindowResize from '@/composables/useWindowResize';
import SliderIndicator from '../SliderIndicator.vue';
import ProductCard from '../ProductCard';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsCarouselV2',
  props: {
  products: {
    type: Array,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { isTablet, isMobile } = useWindowResize();
const forceComputeScroll = ref(0);
const scrollPercentage = ref(0);
const scrollRefreshCounter = ref(0);
const container = ref<HTMLDivElement|null>(null);

const canScrollLeft = computed(() => {
  if (forceComputeScroll.value < 0 || props.products.length === 0 || !container.value) {
    return false;
  }

  return container.value.scrollLeft > 0;
});

const canScrollRight = computed(() => {
  if (forceComputeScroll.value < 0 || props.products.length === 0 || !container.value) {
    return false;
  }

  return container.value.scrollLeft < container.value.scrollWidth - container.value.clientWidth;
});

function refreshScrollableState() {
  forceComputeScroll.value = forceComputeScroll.value === 0 ? 1 : 0;
  if (container.value) {
    scrollPercentage.value = (container.value.scrollLeft / (container.value.scrollWidth - container.value.clientWidth));
    console.log(scrollPercentage.value);
  }
  if (scrollRefreshCounter.value > 5) {
    return;
  }

  if (props.products.length !== 0 && container.value
    && container.value.scrollWidth === container.value.clientWidth) {
    nextTick(() => {
      scrollRefreshCounter.value += 1;
      refreshScrollableState();
    });
  }
}

function getScrollIncrement() {
  if (!container.value) {
    return 0;
  }

  return (container.value.scrollWidth / props.products.length);
}

function goPrev() {
  if (!canScrollLeft.value || !container.value) {
    return;
  }

  container.value.scrollLeft -= getScrollIncrement();
}

function goNext() {
  if (!canScrollRight.value || !container.value) {
    return;
  }

  container.value.scrollLeft += getScrollIncrement();
}

onMounted(() => {
  nextTick(() => {
    refreshScrollableState();
  });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "product-carousel-v2__list",
      ref_key: "container",
      ref: container,
      onScroll: refreshScrollableState
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products, (product) => {
        return (_openBlock(), _createBlock(_unref(ProductCard), {
          class: "product-carousel-v2__product",
          key: product.articleNumber,
          product: product,
          useOneImage: _unref(isTablet) || _unref(isMobile),
          disableHover: _unref(isTablet) || _unref(isMobile),
          reinitializeImagesOnResize: true
        }, null, 8, ["product", "useOneImage", "disableHover"]))
      }), 128))
    ], 544),
    _createElementVNode("div", _hoisted_2, [
      (_unref(canScrollLeft) || _unref(canScrollRight))
        ? (_openBlock(), _createBlock(SliderIndicator, {
            key: 0,
            class: "product-carousel-v2__indicator",
            slides: __props.products.length,
            currentSlide: (scrollPercentage.value * props.products.length) + (1 - scrollPercentage.value)
          }, null, 8, ["slides", "currentSlide"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_unref(canScrollLeft))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _withModifiers(goPrev, ["prevent"]),
              class: "product-carousel-v2__navigation-prev"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true),
        (_unref(canScrollRight))
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _withModifiers(goNext, ["prevent"]),
              class: "product-carousel-v2__navigation-next"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})